import React, { useContext } from 'react';
import { RowDataItem } from 'widgets/openSubmissions/grid/OpenSubmissionsGrid';
import orderBy from 'lodash/orderBy';
import { getVenueTypeText, VenueType } from '../../../utils/venueTypeUtils';
import './OpenSubmissionCapsuleLabels.scss';
import Tooltip from 'utils/components/Tooltip/Tooltip';
import AppContext from '../../../app/AppContext';

type OpenSubmissionCapsuleLabelsRow = {
    vt: VenueType;
    orderQty: number;
    filled: number;
};
type OpenSubmissionCapsuleLabelsRowDict = {
    [vt: string]: OpenSubmissionCapsuleLabelsRow;
};

export function OpenSubmissionCapsuleLabels(props: {
    data: RowDataItem[];
    onClickVenueType: (vt: VenueType) => void;
}) {
    const { data, onClickVenueType } = props;
    const byVt: OpenSubmissionCapsuleLabelsRowDict = {};

    data.reduce<OpenSubmissionCapsuleLabelsRowDict>((dict, row) => {
        if (!dict[row.executionVenueType]) {
            dict[row.executionVenueType] = {
                vt: row.executionVenueType,
                filled: row.filled,
                orderQty: row.orderQty,
            };
        } else {
            dict[row.executionVenueType].orderQty += row.orderQty;
            dict[row.executionVenueType].filled += row.filled;
        }
        return dict;
    }, byVt);

    const rows: OpenSubmissionCapsuleLabelsRow[] = orderBy(
        Object.values(byVt),
        ['filled', 'orderQty'],
        ['desc', 'desc']
    );

    return (
        <div className="OpenSubmissionCapsuleLabels">
            {rows.map((row) => (
                <Row
                    key={row.vt}
                    row={row}
                    onClickVenueType={onClickVenueType}
                />
            ))}
        </div>
    );
}

function Row(props: {
    row: OpenSubmissionCapsuleLabelsRow;
    onClickVenueType: (vt: VenueType) => void;
}) {
    const {
        onClickVenueType,
        row: { vt, filled },
    } = props;

    const { numberFormat } = useContext(AppContext);

    const vtDesc = getVenueTypeText(vt);

    return (
        <div
            className="open-submission-vt-row"
            onClick={() => onClickVenueType(vt)}
        >
            <div className={`vt-desc`}>
                <Tooltip neverHide={true} text={vtDesc}>
                    {vtDesc}
                </Tooltip>
            </div>
            <div className={`vt-filled`}>
                <Tooltip
                    neverHide={true}
                    text={`${numberFormat.n0(filled)}% filled`}
                >
                    {numberFormat.n0(filled)}%
                </Tooltip>
            </div>
        </div>
    );
}
